import Component from "./PagePricing.vue";
export default Component;
